// ----------- -> General content <- -----------

export const FALLBACK_IMAGE = require(
  '../assets/images/fallback-image.png'
);

// ----------- -> #1 Home page content <- -----------

/*
 * Hero video
 *
 * The actual hero video is loaded from Cockpit Global.heroVideo.
 * These can be removed later too if you do not want a local fallback.
 */

export const LOGO_WHITE = require(
  '../assets/images/Assets/Logos/logo-classic-white.png'
);

/*
 * Expertise Section
 *
 * Keep these only while Expertise is still using local assets.
 */

export const DESIGN_CARD_IMG = require(
  '../assets/images/Homepage/Expertise_Design.jpg'
);

export const BIODESIGN_CARD_IMG = require(
  '../assets/images/Homepage/Expertise_Biotekton.jpg'
);

export const AUTOMATION_CARD_IMG = require(
  '../assets/images/Homepage/Expertise_Automation.jpg'
);

export const MAPPING_CARD_IMG = require(
  '../assets/images/Homepage/Expertise_Survey.jpg'
);

export const LOGO_DESIGN = require(
  '../assets/images/logo-design.png'
);

export const LOGO_MAPPING = require(
  '../assets/images/logo-mapping.png'
);

export const LOGO_AUTOMATION = require(
  '../assets/images/logo-automation.png'
);

export const LOGO_BIODESIGN = require(
  '../assets/images/logo-biodesign.png'
);

/*
 * How We Work Section
 *
 * Keep these only while this section still uses local assets.
 */

export const HOW_WE_WORK_IMG = require(
  '../assets/images/Homepage/HowWeWork_Desktop.jpg'
);

export const HOW_WE_WORK_IMG_MOBILE = require(
  '../assets/images/Homepage/HowWeWork_Phone.jpg'
);

/*
 * Removed from this file because they now come from Cockpit:
 *
 * - Header logos
 * - World map
 * - Team portraits
 * - Collaborator logos
 * - Project covers
 * - Project galleries
 * - Project concept images
 * - Project process images
 */